

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface AdvanceMasterParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface AdvanceMaster {
    id?: number;
   regId:any;
   admissionId:any;
   advanceDate:Date;
   advanceTotal:any;
   createdBy:string;
   createdDate:any;
   cancelFlag:string;
   cancelReason:string;  


    tenantId: any;
    branchId: any;
  
  parameters?: AdvanceMasterParameter[];
  links?: any;
}

export abstract class AdvanceMasterData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<AdvanceMaster[]>;
  abstract create(url: string, data: AdvanceMaster): Observable<AdvanceMaster[]>;
  abstract update(url: string, data: AdvanceMaster): Observable<AdvanceMaster>;
  abstract delete(url: string): Observable<any>;
 
}
